import React from "react";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import LuckyMoney from "../OrderDetails/OrderBasicInfo/LuckyMoney";

// 实付金额列
type Props = {
    order: OrderDTO;
};

const PaymentsColumn: React.FC<Props> = observer(({ order }) => {
    return (
        <td>
            <div>
                {order.payments}
                <LuckyMoney orderTags={order.tags} />
                {order.shippingFee ? <p className="shipping-cost">运费{order.shippingFee}</p> : null}
                {order.codAmounts && order.codAmounts !== order.payments ? (
                    <p className="small">代收:{order.codAmounts}元</p>
                ) : null}
            </div>
        </td>
    );
});

export default PaymentsColumn;
